export default __webpack_public_path__ + "static/media/logo.6f4f71aa.png";